import CheckInput from 'assets/components/inputs/check/CheckInput';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import { inputStyles } from 'assets/components/inputs/Input';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import { getLocales } from 'assets/locales/Locale';
import { ValidationRegex } from 'assets/utils/data/Regex';
import ClaimTypeDataPointInputType from 'models/enums/ClaimTypeDataPointInputType';

type ClaimTypeInputSwitchProps = {
  detail: Utils.FormData<Model.IClaimJobDataPoint>;
  onUpdate(value: string, detailId: number): void;
};

export default function ClaimTypeInputSwitch({ detail, onUpdate }: ClaimTypeInputSwitchProps) {
  const { lang } = getLocales();
  const isRequired = detail.isRequired && detail.value == undefined;

  return (
    <>
      {detail.type === ClaimTypeDataPointInputType.Number && (
        <NumberInput
          name="value"
          label={detail.name}
          error={isRequired ? lang.required : undefined}
          value={Number(detail.value)}
          style={{ width: '100%' }}
          onChange={({ value }) => {
            onUpdate(value === null ? '' : String(value), detail.claimTypeDataPointId);
          }}
        />
      )}
      {detail.type === ClaimTypeDataPointInputType.Any && (
        <TextInput
          name="value"
          label={detail.name}
          error={isRequired ? lang.required : undefined}
          value={detail.value ?? ''}
          onChange={({ value }) => {
            onUpdate(value, detail.claimTypeDataPointId);
          }}
        />
      )}
      {detail.type === ClaimTypeDataPointInputType.Text && (
        <TextInput
          name="value"
          label={detail.name}
          error={isRequired ? lang.required : undefined}
          value={detail.value ?? ''}
          onChange={({ value }) => {
            if (value === '' || ValidationRegex.letters.test(value)) {
              onUpdate(value, detail.claimTypeDataPointId);
            }
          }}
        />
      )}
      {detail.type === ClaimTypeDataPointInputType.Alphanumeric && (
        <TextInput
          name="value"
          label={detail.name}
          error={isRequired ? lang.required : undefined}
          value={detail.value ?? ''}
          onChange={({ value }) => {
            if (value === '' || !ValidationRegex.alphanumeric.test(value)) {
              console.log(value);
              onUpdate(value, detail.claimTypeDataPointId);
            }
          }}
        />
      )}
      {detail.type === ClaimTypeDataPointInputType.Date && (
        <DateInput
          name="value"
          isLocal={true}
          label={detail.name}
          error={isRequired ? lang.required : undefined}
          value={detail.value}
          style={{ width: '100%' }}
          onChange={({ value }) => {
            onUpdate(value, detail.claimTypeDataPointId);
          }}
        />
      )}
      {detail.type === ClaimTypeDataPointInputType.Boolean && (
        <CheckInput
          name="value"
          class={inputStyles.check.checkbox}
          value={detail.value === 'true'}
          onChange={({ value }) => {
            onUpdate(String(value), detail.claimTypeDataPointId);
          }}
          label={detail.name}
        />
      )}
      {detail.type === ClaimTypeDataPointInputType.Price && (
        <NumberInput
          name="value"
          label={detail.name}
          error={isRequired ? lang.required : undefined}
          value={Number(detail.value)}
          step={0.01}
          min={0}
          style={{ width: '100%' }}
          onChange={({ value }) => {
            onUpdate(value === null ? '' : String(value), detail.claimTypeDataPointId);
          }}
        />
      )}
    </>
  );
}
